import React from 'react';
import { enableTouch } from '../utilities/tabletUtil';

export const TouchDeviceInvisible = props => {
  const visible = () => {
    return enableTouch() ? 'tablet-invisible' : 'tablet-visible';
  };
  return <span className={visible()}>{props.children}</span>;
};



// WEBPACK FOOTER //
// ./src/components/TouchDeviceInvisible.jsx